const parseBrowser = (ua) => {
  if (/Edg\//i.test(ua)) {
    const match = ua.match(/Edg\/([\d.]+)/i)
    return { browser: "Edge", browser_version: match?.[1] ?? "" }
  }
  if (/OPR\//i.test(ua) || /Opera/i.test(ua)) {
    const match = ua.match(/(?:OPR|Opera)\/([\d.]+)/i)
    return { browser: "Opera", browser_version: match?.[1] ?? "" }
  }
  if (/Firefox\//i.test(ua)) {
    const match = ua.match(/Firefox\/([\d.]+)/i)
    return { browser: "Firefox", browser_version: match?.[1] ?? "" }
  }
  if (/Chrome\//i.test(ua)) {
    const match = ua.match(/Chrome\/([\d.]+)/i)
    return { browser: "Chrome", browser_version: match?.[1] ?? "" }
  }
  if (/Safari\//i.test(ua)) {
    const match = ua.match(/Version\/([\d.]+)/i)
    return { browser: "Safari", browser_version: match?.[1] ?? "" }
  }
  return { browser: "Unknown", browser_version: "" }
}

const parseOS = (ua) => {
  if (/Windows/i.test(ua)) return "Windows"
  if (/Macintosh|Mac OS X/i.test(ua)) return "macOS"
  if (/iPhone|iPad|iPod/i.test(ua)) return "iOS"
  if (/Android/i.test(ua)) return "Android"
  if (/Linux/i.test(ua)) return "Linux"
  return "Unknown"
}

const parseDeviceType = (ua) => {
  if (/iPad/i.test(ua)) return "tablet"
  if (/Mobi|Android|iPhone|iPad/i.test(ua)) return "mobile"
  return "desktop"
}

const collectClientMetadata = () => {
  const ua = navigator.userAgent || ""
  const { browser, browser_version } = parseBrowser(ua)

  const extra = {
    pixel_ratio: window.devicePixelRatio,
    online: navigator.onLine,
    cookie_enabled: navigator.cookieEnabled,
    platform: navigator.platform,
    color_depth: window.screen.colorDepth,
    hardware_concurrency: navigator.hardwareConcurrency,
    connection: navigator.connection?.effectiveType ?? null
  }

  return {
    browser,
    browser_version,
    os: parseOS(ua),
    device_type: parseDeviceType(ua),
    screen_size: `${window.screen.width}x${window.screen.height}`,
    viewport_size: `${window.innerWidth}x${window.innerHeight}`,
    user_agent: ua,
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    url: window.location.href,
    referrer: document.referrer || null,
    extra_metadata: JSON.stringify(extra)
  }
}

export default collectClientMetadata
